import { render, staticRenderFns } from "./SkeletonOPComponent.vue?vue&type=template&id=fb7096ec&scoped=true&"
import script from "./SkeletonOPComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonOPComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonOPComponent.vue?vue&type=style&index=0&id=fb7096ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7096ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
